import CancelPolicy from 'domains/models/cancel_policy';
import { z } from 'zod';

export type CancelPolicyCreateBody = z.infer<
  typeof schemaCancelPolicyCreateBody
>;
export const schemaCancelPolicyCreateBody = z.object({
  uid: z.string(),
  name: z.string(),
  description: z.string(),
});

export type CancelPolicyUpdateBody = z.infer<
  typeof schemaCancelPolicyUpdateBody
>;
export const schemaCancelPolicyUpdateBody = z.object({
  name: z.string(),
  description: z.string(),
});

export type CancelPolicyCreateResult = z.infer<
  typeof schemaCancelPolicyCreateResult
>;
export const schemaCancelPolicyCreateResult = z.object({
  id: z.number(),
});

export type CancelPolicyItem = z.infer<typeof schemaCancelPolicyItem>;
export const schemaCancelPolicyItem = z.object({
  id: z.number().nullable(),
  uid: z.string(),
  teamId: z.number(),
  name: z.string(),
  description: z.string(),
});

export type CancelPolicyListItem = z.infer<typeof schemaCancelPolicyListItem>;
export const schemaCancelPolicyListItem = z.object({
  id: z.number().nullable(),
  uid: z.string(),
  teamId: z.number(),
  name: z.string(),
  description: z.string(),
});

export const toItem = (cancelPolicy: CancelPolicy): CancelPolicyItem => {
  return {
    id: cancelPolicy.id,
    uid: cancelPolicy.uid,
    teamId: cancelPolicy.teamId,
    name: cancelPolicy.name,
    description: cancelPolicy.description,
  };
};

export const toListItem = (
  cancelPolicy: CancelPolicy,
): CancelPolicyListItem => {
  return {
    id: cancelPolicy.id,
    uid: cancelPolicy.uid,
    teamId: cancelPolicy.teamId,
    name: cancelPolicy.name,
    description: cancelPolicy.description,
  };
};
